import { Component, Input } from '@angular/core';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-added-to-cart',
  templateUrl: './product-added-to-cart.component.html',
  styleUrls: ['./product-added-to-cart.component.scss']
})
export class ProductAddedToCartComponent {
  @Input('title') title: string = '';
  @Input('description') description: string = '';
  @Input('textFirstButton') textFirstButton: string = '';
  @Input('textSecondButton') textSecondButton: string = '';
  @Input() firstButtonAction: () => void = () => {};
  @Input() secondButtonAction: () => void = () => {};
  constructor(public activeModal: NgbActiveModal){
    
  }
  faX = faX;

  onNo() {
    this.activeModal.close('close');
  }

  onFirstButtonClick() {
    this.firstButtonAction();
    this.activeModal.close('firstButton');
  }

  onSecondButtonClick() {
    this.secondButtonAction();
    this.activeModal.close('secondButton');
  }
}
